import { MouseEventHandler } from 'react'
import { IconArrow } from '../../SliderUtils/ArrowNavigation'
import Link from '../../Link/Link'
// import useCurrentLocale from '../../../../core/hook/useCurrentLocale'

type HeaderNavigationMobileLinkProps = {
  title: string
  href: string
  onClick?: () => void
  isBacktrack?: boolean
  noArrow?: boolean
  bold?: boolean
  onClose?: () => void
}

const HeaderNavigationMobileLink = ({
  title,
  href,
  onClick,
  isBacktrack = false,
  noArrow = false,
  bold = false,
  //  onClose
}: HeaderNavigationMobileLinkProps) => {
  //  const locale = useCurrentLocale()

  const onClickLink: MouseEventHandler<HTMLAnchorElement> = (e) => {
    if (onClick) {
      e.preventDefault()
      e.nativeEvent.stopImmediatePropagation()
      onClick()
    }

    // 2025-02-07: This code seems useless and it's breaking the
    // mobile menu
    //
    // 2024-XX-XX: if link is current page close menu
    // if(onClose){
    //   const pathname = "/"+ locale + "/" + href;
    //   if(pathname == window.location.pathname){
    //     onClose();
    //   }
    // }
  }

  return (
    <Link
      href={href}
      onClick={onClickLink}
      className={`header-navigation-mobile-link ${noArrow ? 'no-arrow' : ''} ${
        bold ? 'bold' : ''
      }`}>
      <span className='header-navigation-mobile-link-title'>
        {isBacktrack && <IconArrow className='header-navigation-mobile-link-arrow previous' />}
        {title}
      </span>
      {!isBacktrack && <IconArrow className='header-navigation-mobile-link-arrow' />}
    </Link>
  )
}

export default HeaderNavigationMobileLink
